import { ProCard } from '@ant-design/pro-components'
import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { ServiceAreaDisplayCards } from '@app/icare/routes/_app/pflegedienste/-components/ServiceAreaDisplayCards'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/sanitaetshaeuser/$id/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const { data } = useQuery(localQueryEntityOptions(params.id))

  if (!data) {
    return <ProCard loading />
  }

  return <ServiceAreaDisplayCards entity={data} />
}
